import { render, staticRenderFns } from "./ResumeView.vue?vue&type=template&id=5325a560&scoped=true"
import script from "./ResumeView.vue?vue&type=script&lang=ts"
export * from "./ResumeView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5325a560",
  null
  
)

export default component.exports